import { render } from "./two-step-verification-two.vue?vue&type=template&id=1bd39250"
import script from "./two-step-verification-two.vue?vue&type=script&lang=js"
export * from "./two-step-verification-two.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__